import React from 'react';
import { CFFieldElements } from '../Field.styles';
export const SelectFieldLabel = ({ value, fieldSize, options, placeholder, }) => {
    const { FieldValue } = CFFieldElements;
    if (value.length > 0) {
        return (React.createElement(FieldValue, { fieldSize: fieldSize, isPlaceholder: false }, options
            .filter(({ selected }) => selected)
            .map(({ id, label }, index) => (React.createElement(React.Fragment, { key: id },
            index > 0 && ', ',
            label)))));
    }
    else if (placeholder) {
        return (React.createElement(FieldValue, { fieldSize: fieldSize, isPlaceholder: true }, placeholder));
    }
    return React.createElement(FieldValue, { fieldSize: fieldSize });
};
